module.exports = __webpack_public_path__ + "static/better-employee-03-540w-422a2552c1cb788fdfb8eddcc6416d3b.jpg";